<template lang="pug">
  .container-outlay-detail.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/outlay") 营销账户管理
          el-breadcrumb-item 营销账户详情
    c-box
      c-header-small
        template(slot="left") 账户信息
        template(slot="right")
          el-button(type="primary", @click="showEditAccount") 修改账户名称
          el-button(type="primary", @click="showAuthApp") 应用授权
        //-   el-button(type="primary", @click="toCharge") 账户充值
      el-form(:model="accountDetail",label-position="right",label-width="150px")
        el-row(:gutter="10")
          el-col(:span="10")
            el-form-item(label="账户名称") {{ accountDetail.account_name }}
          el-col(:span="14")
            el-form-item(label="账户 ID") {{ accountDetail.outlay_account_id }}
    c-box
      el-form(:model="accountDetail",label-position="right",label-width="125px")
        //- el-form-item(label="账户余额")
          .flex-content
            .huge.bold {{ accountDetail.account_amount | toYuan }}
            //- el-button(type="primary", @click="toPurchasePackage").display-block 转换
            //- el-button(type="primary", @click="toChargeApply").display-block 充值查询
        //- hr
        el-row(:gutter="10")
          el-col(:span="10")
            el-form-item(label="积力宝")
              .flex-content
                .huge.bold {{ coinDetail.present_balance }}
                el-button(type="primary", @click="toCoin").display-block 详情
                el-button(type="primary", @click="showCoinSettings").display-block 配置
        //-   el-col(:span="14")
        //-     el-form-item(label="现金券")
        //-       .flex-content
        //-         .display-block 余额&nbsp;&nbsp;
        //-         .huge.bold {{ couponDetail.present_balance | toYuan }}
        //-         .display-block &nbsp;&nbsp;可用现金券总额&nbsp;&nbsp;
        //-         .huge.bold
        //-           template(v-if="typeof couponDetail.amount === 'number'") {{ couponDetail.amount | toYuan }}
        //-           template(v-else) -
        //-         el-button(@click="toCoupon").display-block 详情

    c-box
      c-header-small
        template(slot="left") 额度动态
        template(slot="right")
          el-button(type="primary", @click="toActivity") 查看更多
      el-table(:data="activityList", fit)
        el-table-column(property="act_date", label="操作时间", min-width="200", show-tooltip-when-overflow)
        el-table-column(label="操作类型", min-width="150", show-tooltip-when-overflow, v-slot="{ row }") {{ row.act_type | outlay_act_type }}
        el-table-column(label="额度", min-width="150", show-tooltip-when-overflow, v-slot="{ row }").
          {{ !(row.act_type === 2 || row.act_type === 3 || row.act_type === 5) ? '+' : '-' }}{{ row.amount | toYuan }}
        el-table-column(property="operator", label="操作者", min-width="150", show-tooltip-when-overflow)
        el-table-column(label="状态", min-width="100", show-tooltip-when-overflow, v-slot="{ row }") {{ row.status | outlay_act_status }}
    
    el-dialog(title="修改账户名称", :visible.sync="editAccount.show")
      el-form(:model="editAccount", label-position="right", label-width="125px")
        el-form-item(label="营销账户名称", required)
          el-input(v-model="editAccount.account_name")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveEditAccount()") 保存
        el-button(@click="hideEditAccount()") 取消

    el-dialog(title="积力宝配置", :visible.sync="coinSettings.show", v-loading="coinSettings.loading", :element-loading-fullscreen="false")
      el-form(:model="coinSettings", label-position="right", label-width="125px")
        //- el-form-item(label="允许充值")
          el-checkbox(v-model="coinSettings.rechargable")
        el-form-item(label="允许分发")
          el-checkbox(v-model="coinSettings.distributable")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveCoinSettings()") 保存
        el-button(@click="hideCoinSettings()") 取消

    el-dialog(title="设置应用授权", :visible.sync="authApp.show")
      el-form(:model="authApp", label-position="right", label-width="100px")
        el-form-item(label="") 授权合作的应用操作您的营销账户，创建、发放积力宝和现金券。
        el-form-item(label="注意") 请不要频繁修改授权，以免应用在创建、发放积力宝或现金券时出错。
        .display-table.auth-table(v-loading="authApp.loading", :element-loading-fullscreen="false")
          .display-tr.auth-table-header
            .display-td.auth-table-td &nbsp;
            .display-td.auth-table-td(v-for="a in authApp.app_list")
              .auth-app-container
                .auth-app-icon(:class="'auth-app-icon-' + a.icon")
                .display-block {{ a.name }}
          .display-tr.auth-table-row(v-for="(bind, $index) in authApp.binding_array", :key="$index")
            .display-td.auth-table-td {{ authApp.biz_list[$index].biz_name }}
            .display-td.auth-table-td(v-for="(b, $$index) in bind.binding", :key="$$index")
              el-checkbox(v-model="b.operation", :true-label="1", :false-label="2")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveAuthApp()") 保存
        el-button(@click="hideAuthApp()") 取消

    verifier(ref="authApp", @success_verify="toSaveAuthApp", scene="BIND_APP", opt="MCH_VERIFY")
</template>

<script>
export default {
  data () {
    return {
      accountDetail:  {},
      coinDetail:     {
        present_balance:  '-',
      },
      coinSettings: {
        show:           false,
        acl:            0,
        rechargable:    false,
        distributable:  false,
        loading:        false,
      },

      couponDetail:   {
        amount:           '-',
        present_balance:  '-',
      },

      editAccount:    {
        show:         false,
        account_name: null,
      },

      authApp: {
        show:               false,
        loading:            false,
        outlay_account_id:  null,
        biz_ticket:         null,

        app_list:           [],
        binding_array:      [],
        biz_list:           [],
      },

      activityList:   [],
    };
  },
  computed: {
    outlay_account_id () {
      return this.$route.params.outlay_account_id;
    },
  },
  methods: {
    toCoin () {
      this.$router.push(`/outlay/${this.outlay_account_id}/coin`);
    },
    toCoupon () {
      this.$router.push(`/outlay/${this.outlay_account_id}/coupon`);
    },
    toActivity () {
      this.$router.push(`/outlay/${this.outlay_account_id}/activity`);
    },

    toCharge () {
      this.$router.push(`/outlay/${this.outlay_account_id}/recharge`);
    },
    toChargeApply () {
      this.$router.push(`/outlay/${this.outlay_account_id}/rechargeApply`);
    },

    toPurchasePackage () {
      this.$router.push(`/outlay/${this.outlay_account_id}/package`);
    },

    showEditAccount () {
      this.editAccount = {
        show:         true,
        account_name: this.accountDetail.account_name,
      };
    },
    hideEditAccount () {
      this.editAccount = {
        show:         false,
        account_name: null,
      };
    },
    saveEditAccount () {
      const account_name = this.editAccount.account_name ? this.editAccount.account_name.trim() : '';
      if (!account_name) {
        this.$message({
          type:     'warning',
          message:  `请输入有效的账户名称。`,
        });
        return;
      } else if (account_name.length > 20) {
        this.$message({
          type:     'warning',
          message:  `账户名称不能超过20字。`,
        });
        return;
      }

      const params = {
        outlay_account_id:  this.outlay_account_id,
        account_name,
      };
      this.$store.dispatch('EDIT_OUTLAY_ACCOUNT', params).then(() => {
        this.getAccountDetail();
        this.hideEditAccount();

        this.$message({
          type:     'success',
          message:  '修改成功'
        });
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `修改失败。${code}：${msg}`,
        });
      });
    },

    showCoinSettings () {
      this.coinSettings = {
        show:           true,
        acl:            0,
        rechargable:    false,
        distributable:  false,
        loading:        true,
      };
      this.getCoinSettings();
    },
    hideCoinSettings () {
      this.coinSettings = {
        show:           false,
        acl:            0,
        rechargable:    false,
        distributable:  false,
        loading:        false,
      };
    },
    getCoinSettings () {
      const account_id = this.outlay_account_id;
      return this.$store.dispatch('GET_OUTLAY_ACCOUNT_COIN_SETTINGS', account_id).then((data) => {
        if (this.coinSettings.show) {
          const acl = parseInt(data.acl);
          this.coinSettings.acl = acl;

          switch (acl) {
            case 1:   this.coinSettings.rechargable = true; this.coinSettings.distributable = false; break;
            case 2:   this.coinSettings.rechargable = false; this.coinSettings.distributable = true; break;
            case 3:   this.coinSettings.rechargable = true; this.coinSettings.distributable = true; break;
          }
        }
        return data;
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取营销账户积分配置。${code}：${msg}`,
        });
      }).finally(() => {
        if (this.coinSettings.show) {
          this.coinSettings.loading = false;
        }
      });
    },
    saveCoinSettings () {
      let acl = 0;
      if (this.coinSettings.rechargable) {
        acl += 1;
      }
      if (this.coinSettings.distributable) {
        acl += 2;
      }

      const params = {
        outlay_account_id:  this.outlay_account_id,
        acl,
      };
      return this.$store.dispatch('SET_OUTLAY_ACCOUNT_COIN_SETTINGS', params).then((data) => {
        this.hideCoinSettings();
        this.$message({
          type:     'success',
          message:  '设置成功'
        });
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `设置应用授权失败。${code}：${msg}`,
        });
      });
    },

    getAccountDetail () {
      const account_id = this.outlay_account_id;

      return this.$store.dispatch('GET_OUTLAY_ACCOUNT_DETAIL', account_id).then((data) => {
        this.accountDetail = data;
        return data;
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取账户信息失败。${code}：${msg}`,
        });
      });
    },
    getCoinDetail () {
      const account_id = this.outlay_account_id;

      return this.$store.dispatch('GET_OUTLAY_ACCOUNT_COIN_DETAIL', account_id).then((data) => {
        this.coinDetail = data || {
          present_balance:  '-',
        };
        return data;
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取账户余额信息失败。${code}：${msg}`,
        });
      });
    },
    // getCouponDetail () {
    //   const account_id = this.outlay_account_id;

    //   return this.$store.dispatch('GET_OUTLAY_ACCOUNT_COUPON_DETAIL', account_id).then((data) => {
    //     this.couponDetail = data || {
    //       amount:           '-',
    //       present_balance:  '-',
    //     };
    //     return data;
    //   }).catch(({ code, msg }) => {
    //     this.$message({
    //       type:     'error',
    //       message:  `获取账户现金券信息失败。${code}：${msg}`,
    //     });
    //   });
    // },

    getActivityBrief () {
      return this.$store.dispatch('GET_OUTLAY_ACCOUNT_ACTIVITY_LIST', {
        outlay_account_id: this.outlay_account_id,
        limit:    5,
        offset:   0,
        stat:     true,
      }).then((data) => {
        this.activityList = data.list || [];
        return data;
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取余额动态列表。${code}：${msg}`,
        });
      });
    },

    showAuthApp () {
      this.authApp = {
        show:               true,
        loading:            false,
        outlay_account_id:  this.outlay_account_id,
        biz_ticket:         null,

        app_list:           [],
        binding_array:      [],
        biz_list:           [],
      };
      this.getAuthAppList();
    },
    hideAuthApp () {
      this.authApp = {
        show:               false,
        loading:            false,
        outlay_account_id:  null,
        biz_ticket:         null,

        app_list:           [],
        binding_array:      [],
        biz_list:           [],
      };
    },
    getAuthAppList () {
      const account_id = this.outlay_account_id;
      this.authApp.loading = true;

      return this.$store.dispatch('GET_AUTH_APP_LIST', account_id).then(({ app_list, binding_list, biz_list }) => {
        let list = [];
        biz_list.forEach((b) => {
          let biz = Object.assign({}, b, {
            binding:  [],
          });
          app_list.forEach((a) => {
            const app = {
              app_id:     a.app_id,
              biz_type:   biz.biz_type,
              operation:  2,
            };
            const binding = binding_list.find((bind) => {
              return bind.app_id === app.app_id && bind.biz_type === app.biz_type;
            });
            if (binding) {
              app.operation = 1;
            }
            biz.binding.push(app);
          });
          list.push(biz);
        });

        this.authApp.app_list = app_list;
        this.authApp.binding_array = list;
        this.authApp.biz_list = biz_list;

        return { app_list, binding_list, biz_list };
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `获取应用绑定信息失败。${code}：${msg}`,
        });
      }).finally(() => {
        this.authApp.loading = false;
      });
    },
    saveAuthApp () {
      this.$refs.authApp.init();
    },
    toSaveAuthApp (biz_ticket) {
      let bind_req = [];
      this.authApp.binding_array.forEach((v) => {
        bind_req = [...bind_req, ...v.binding];
      });

      const jsonSource = {
        outlay_account_id:  this.outlay_account_id,
        bind_req,
      };
      const params = {
        json:   JSON.stringify(jsonSource),
        biz_ticket,
      };
      return this.$store.dispatch('BIND_AUTH_APP', params).then((data) => {
        this.hideAuthApp();
        this.$message({
          type:     'success',
          message:  '设置成功'
        });
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `设置应用授权失败。${code}：${msg}`,
        });
      });
    },

    init () {
      this.getAccountDetail();
      this.getCoinDetail();
    //   this.getCouponDetail();
      this.getActivityBrief();
    },
  },
  mounted () {
    if (!this.outlay_account_id) {
      this.$router.replace('/outlay');
    } else {
      this.init();
    }
  },
};
</script>

<style lang="less">
@import (reference) "../../assets/general";

.container-outlay {
  .flex-content {
    .flex(center, flex-start, row);

    .el-button {
      margin-left:  1em;
    }
  }

  .auth-table {
    .display-table;
  }
  .auth-table-header {
    .display-tr;
  }
  .auth-table-row {
    .display-tr;

    .auth-table-td {
      &:first-child {
        .align-right;
      }
    }
  }
  .auth-table-td {
    .align-center;
    padding:  .5em 0;
  }

  .auth-app-container {
    .flex(center, center);
  }
  .auth-app-icon {
    width:    32px;
    height:   32px;
    margin-right:   8px;

    background-position:  center center;
    background-size:      contain;
    background-repeat:    no-repeat;
  }
}
</style>
